export const FONT_PAIRINGS = [
  {
    id: "pairing_1",
    name: "Cormorant & Montserrat (Classic Royal)",
    serif: "'Cormorant Garamond', Georgia, serif",
    body: "'Montserrat', sans-serif",
    script: "'Great Vibes', cursive",
    url: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Great+Vibes&family=Montserrat:wght@300;400;500;600&display=swap",
  },
  {
    id: "pairing_2",
    name: "Playfair & Plus Jakarta (Editorial Romance)",
    serif: "'Playfair Display', Georgia, serif",
    body: "'Plus Jakarta Sans', sans-serif",
    script: "'Alex Brush', cursive",
    url: "https://fonts.googleapis.com/css2?family=Alex+Brush&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400&family=Plus+Jakarta+Sans:wght@300;400;500;600&display=swap",
  },
  {
    id: "pairing_3",
    name: "Cinzel & Outfit (Grand Monumental)",
    serif: "'Cinzel', serif",
    body: "'Outfit', sans-serif",
    script: "'Sacramento', cursive",
    url: "https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Outfit:wght@300;400;500;600&family=Sacramento&display=swap",
  },
  {
    id: "pairing_4",
    name: "Bodoni & Inter (Minimalist Fine Art)",
    serif: "'Bodoni Moda', Georgia, serif",
    body: "'Inter', sans-serif",
    script: "'Parisienne', cursive",
    url: "https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,500;0,6..96,600;1,6..96,400&family=Inter:wght@300;400;500;600&family=Parisienne&display=swap",
  },
];

export const getPairing = (id) => FONT_PAIRINGS.find((p) => p.id === id) || FONT_PAIRINGS[0];
